import { Box, Flex, Skeleton, SkeletonText, VStack } from "@chakra-ui/react";
import { FunctionComponent } from "react";

export const Loading: FunctionComponent = () => {
    return (
        <VStack align="stretch" spacing={0} height="100vh">
            <Flex align="center" gap={4} padding="1rem 1.5rem" borderBottom="1px solid" borderColor="gray.100">
                <Skeleton height="2.5rem" width="8rem" />
                <Box flex="1" />
                <Skeleton height="2rem" width="2rem" borderRadius="full" />
            </Flex>
            <Box flex="1" padding="2rem">
                <Skeleton height="2rem" width="16rem" marginBottom="1.5rem" />
                <SkeletonText noOfLines={4} spacing={4} skeletonHeight={3} />
            </Box>
        </VStack>
    );
};
